import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formatter } from "@cgn/framework-ui-components/v1";
import style from "./DrawerStyle";

const removeMarkdown = (md, options) => {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty("listUnicodeChar")
    ? options.listUnicodeChar
    : false;
  options.stripListLeaders = options.hasOwnProperty("stripListLeaders")
    ? options.stripListLeaders
    : true;
  options.gfm = options.hasOwnProperty("gfm") ? options.gfm : true;

  var output = md || "";

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, "");

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(
          /^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm,
          options.listUnicodeChar + " $1"
        );
      else output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, "$1");
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, "\n")
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, "")
        // Strikethrough
        .replace(/~~/g, "")
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, "");
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, "")
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, "")
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, "")
      .replace(/\s{0,2}\[.*?\]: .*?$/g, "")
      // Remove images
      .replace(/\!\[.*?\][\[\(].*?[\]\)]/g, "")
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, "$1")
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, "")
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, "")
      // Remove atx-style headers
      .replace(
        /^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm,
        "$1$2$3"
      )
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, "$2")
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, "$2")
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, "$2")
      // Remove inline code
      .replace(/`(.+?)`/g, "$1")
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, "\n\n");
  } catch (e) {
    console.error(e);
    return md;
  }
  return output;
};

class Messaggio extends Component {
  propTypes = {
    data: PropTypes.any,
    onPreview: PropTypes.func,
  };

  state = {
    hover: false,
  };

  onHover = () => {
    this.setState({ hover: true });
  };

  outHover = () => {
    this.setState({ hover: false });
  };

  preview = (text) => {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = removeMarkdown(text);
    var testoFinale = tmp.textContent || tmp.innerText || "";

    if (testoFinale.length < 200) {
      return testoFinale;
    } else {
      return testoFinale.substring(0, 200) + " ...";
    }
  };

  render() {
    const { data, onPreview } = this.props;

    return (
      <div
        style={this.state.hover ? style.quesitoHover : style.quesito}
        onClick={() => onPreview(data.IdInvio)}
        onMouseEnter={this.onHover}
        onMouseLeave={this.outHover}
      >
        <b
          style={style.header}
          dangerouslySetInnerHTML={{ __html: data.Titolo }}
        ></b>
        <br />
        <span>{this.preview(data.Testo)}</span>
        <br />
        <i style={style.subHeader}>{data.CanaleTematico}</i> il{" "}
        <span style={style.data}>
          <Formatter valore={data.DataPubblicazione} tipo="date" /> alle{" "}
          <Formatter valore={data.DataPubblicazione} tipo="hour" />{" "}
        </span>
      </div>
    );
  }
}

export default Messaggio;
